import API from "./API";

/**
 * Exists to centralize Model Name checking functionality, and to ease mocking in tests.
 * @param modelName name of Model to look up
 * @param batchClassId
 * @returns UUID of Model, empty string if Model does not exist.
 */
function modelAlreadyExistsChecker(
  modelName: string,
  batchClassId: string,
): Promise<string> {
  return API.get("/v0/model/findByName/", {
    batchClassId: batchClassId,
    name: encodeURIComponent(modelName),
  })
    .then((value: Response) => {
      if (!value.ok) {
        return "";
      }
      return value.json();
    })
    .catch((err) => {
      console.error(
        "There was an error checking if a Model already exists with this name",
        err,
      );
      return "";
    });
}

export { modelAlreadyExistsChecker };
